import React from 'react'
import OpenSourceComponent from '../../components/openSource/openSource.tsx'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
export default function OpenSource() {

  return (
    <div  >
      <Helmet>
            <title>Open Source — Gopal Goyal</title>
            <meta name='description'
            content='Open source contributions by Gopal Goyal, including the Golem Networks golem-js preview program.'/>
            <meta name='keywords' content='Gopal Goyal open source, Golem Networks, golem-js, contributions'/>
        </Helmet>
      <Header/>
      <OpenSourceComponent/>
      <Footer/>
    </div>
  )
}
